import Container from "@/components/base/Container";
import SectionHeading from "@/components/base/SectionHeading";
import Button from "@/components/base/Button";
import ServiceCard from "@/components/feature/ServiceCard";
import { useServicios } from "@/hooks/usePublicContent";

export default function ServicesSection() {
  const serviceList = useServicios();
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <Container>
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="Qué hacemos"
            title="Servicios de transporte para cada necesidad"
            description="Desde una mudanza completa hasta la distribución diaria de tu empresa, contamos con la unidad y el equipo adecuados."
          />
          <Button to="/servicios" variant="outline" size="md" iconRight="ri-arrow-right-line" className="shrink-0">
            Ver todos los servicios
          </Button>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 md:mt-12">
          {serviceList.slice(0, 6).map((service, index) => (
            <ServiceCard key={service.id} service={service} index={index} />
          ))}
        </div>
      </Container>
    </section>
  );
}